import { Form, Input } from 'antd';
import EyeIcon from 'assets/icons/eye.svg';
//eyeSlash
import EyeSlashIcon from 'assets/icons/eye-slash.svg';
import getMessage from 'utilities/constants/MESSAGE';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';

export const PasswordFormItem = () => {
    return (
        <section style={{ width: '100%', marginTop: 16 }}>
            <div style={{ marginBottom: 16, fontSize: '14px' }} className="label">
                大文字小文字を含む半角英数字(8桁以上)で入力してください。
            </div>
            <Form.Item
                required={false}
                className=" label-form-style "
                name="password"
                label={false}
                rules={[
                    {
                        required: true,
                        message: getMessage('In_Required', 'パスワード'),
                    },
                    {
                        pattern: /^(?=.*?[a-z\d])(?=.*?[A-Z])[!-~]{8,}$/,
                        message: getMessage('Pass_Invalid_2'),
                    },
                ]}
            >
                <Input.Password
                    iconRender={(visible) =>
                        visible ? (
                            <img className="button-style" alt="" src={EyeIcon} />
                        ) : (
                            <img className="button-style" alt="" src={EyeSlashIcon} />
                        )
                    }
                    size="large"
                    style={{ width: '100%' }}
                    placeholder={PLACEHOLDER.PASSWORD}
                    minLength={8}
                />
            </Form.Item>
        </section>
    );
};
